/* eslint semi:0 */
import { connect, } from 'react-redux'
import React, { Component, } from 'react'
import reduxMount from '../../jsCore/utils/reduxMounter'
import {
  isSameCalendarDay, getDateByIso8601string,
  toHourMinuteFromParts, DAY_IN_MILLISECONDS,
  getCurrentIsoStringDate,
} from '../../jsCore/utils/date'
import { t, } from '../../jsCore/providers/i18nProvider/i18nProvider'
import { MOUNT_POINTS, } from '../../jsCore/config/preRenderedSelectorsConfig'
import { isSupportedForDomain, } from '../../jsCore/application/pageDataObject'
import PreloadScores from '../schedule/components/preloadScores'
import NoUpcomingMatches from '../schedule/components/noUpcomingMatches'
import ScheduleDayPager from '../schedule/components/scheduleNavigationScores'
import { TV_SCHEDULE_COMPONENT_STATE_KEY, } from '../tv_channel_selection/tvChannelSelectionContainer'
import {tvScheduleActions, changeTvScheduleDate, fetchData, setLoading, } from '../tv_channel_selection/tvScheduleActions'
import tvChannelSelectionReducer, { transformTvChannelsData, } from '../tv_channel_selection/tvChannelSelectionReducer'
import {dispatch} from '../../jsCore/application/appStore'

const TV_CHANNEL_SCHEDULE_COMPONENT_NAME = 'TvChannelsScheduleContainer'

export function mapStateToProps(state){
  const {
    IS_INITIALIZED, IS_LOADING, channels, channelNames, currentChannelName, scheduleDate,
    minDate, maxDate,
  } = state[TV_SCHEDULE_COMPONENT_STATE_KEY]
  return {
    dispatch,
    channels,
    channelNames,
    currentChannelName,
    IS_INITIALIZED,
    IS_LOADING,
    scheduleDate,
    minDate,
    maxDate
  }
}

function TvChannelShow({
  blockName, date: dateString,
  startTime, title, overview, description,
}){
  const tvChannelScheduledShowProps = {
    title,
    overview,
    startTime,
    key: startTime,
    className: `${ blockName }__show`,
  }
  const timeProps = {
    dateTime: startTime,
    className: `${ blockName }__start-time`,
    children: toHourMinuteFromParts({ dateString, timeString: startTime, }),
  }
  return (
    <li { ...tvChannelScheduledShowProps }>
      <time { ...timeProps } />
      <div className={ `${ blockName }__details` }>
        <h6 className={ `${ blockName }__title` }>{ title }</h6>
        <div className={ `${ blockName }__overview` }>{ overview }</div>
      </div>
    </li>
  )
}

function TvChannelDayShows({ blockName, shows, date, }){
  const dayShowsBaseProps = { blockName: 'tv-channel-day-shows', }
  const tvChannelDayShowsProps = {
    ...dayShowsBaseProps,
    className: `${ blockName }__day-shows ${ dayShowsBaseProps.blockName }`,
    children: shows.map(
      show => TvChannelShow({ ...show, ...dayShowsBaseProps, date, })
    ),
  }
  return <ul { ...tvChannelDayShowsProps } />
}

function TvScheduleShowsMaybeEmpty({ blockName, shows, date, }){
  return (shows && shows.length) ?
    <TvChannelDayShows { ...{ blockName, shows, date, } } /> :
    <NoUpcomingMatches message={ t('homepage.no_matches') } />
}

function TvScheduleFooterMaybeEmpty({ blockName, shows, }){
  const tvScheduleFooterProps = {
    className: `${ blockName }__footer`,
    children: t('pages.tv_programming.disclaimer'),
  }
  return (shows && shows.length) ?
    <footer { ...tvScheduleFooterProps } /> :
    <noscript />
}

const tvChannelScheduleBlockName = 'tv-schedule'


export class TvChannelSchedule extends Component {

  constructor(props){
    super(props)
    const { onMoveToNextDay, onMoveToPrevDay, } = this
    Object.assign(this, {
      onMoveToNextDayBound: onMoveToNextDay.bind(this),
      onMoveToPrevDayBound: onMoveToPrevDay.bind(this),
    })
  }

  doesDayDataExists(scheduleDate){
    const { channels, } = this.props

    const scheduleData = channels.find(({ schedule, }) => schedule && schedule.length > 0)

    return scheduleData && scheduleData.schedule.some(
      ({ date, }) => isSameCalendarDay(
        getDateByIso8601string(date),
        scheduleDate
      )
    )
  }

  onMoveToNextDay(e){
    const { scheduleDate, maxDate, } = this.props
    const nextDay = new Date(scheduleDate.getTime() + DAY_IN_MILLISECONDS)
    if (nextDay <= maxDate) {
      this.changeDayData(nextDay)
    }
  }

  onMoveToPrevDay(e){
    const { scheduleDate, minDate, } = this.props
    const prevDay = new Date(scheduleDate.getTime() - DAY_IN_MILLISECONDS)
    if (prevDay >= minDate) {
      this.changeDayData(prevDay)
    }
  }

  changeDayData(newDate){
    const { dispatch, } = this.props
    const dayDataExists = this.doesDayDataExists(newDate)
    !dayDataExists && dispatch(setLoading())
    dispatch(changeTvScheduleDate(newDate))
    !dayDataExists &&
      dispatch(fetchData(transformTvChannelsData, getCurrentIsoStringDate(newDate)))
  }

  render(){
    const {
      IS_INITIALIZED, IS_LOADING, channels, scheduleDate, currentChannelName, minDate, maxDate,
    } = this.props
    if (!IS_INITIALIZED || IS_LOADING) {
      return <PreloadScores/>
    }
    const blockName = tvChannelScheduleBlockName
    const currentChannel = channels.find(
      ({ channel, }) => channel.name === currentChannelName
    )
    const currentDaySchdule = currentChannel && currentChannel.schedule.find(
      ({ date, }) => isSameCalendarDay(
        getDateByIso8601string(date),
        scheduleDate
      )
    ) || {}
    Object.assign(currentDaySchdule, { blockName, })
    const scheduleDayPagerProps = {
      currentDay: scheduleDate,
      minDate,
      maxDate,
      className: `${ blockName }__day-pager`,
      onMoveToNextDay: this.onMoveToNextDayBound,
      onMoveToPrevDay: this.onMoveToPrevDayBound,
    }
    return (
      <div className={ `${ blockName }__container` }>
        <ScheduleDayPager { ...scheduleDayPagerProps } />
        <TvScheduleShowsMaybeEmpty { ...currentDaySchdule } />
        <TvScheduleFooterMaybeEmpty { ...currentDaySchdule } />
      </div>
    )
  }

}

const TvChannelScheduleContainer = {
  name: TV_CHANNEL_SCHEDULE_COMPONENT_NAME,
  stateKey: TV_SCHEDULE_COMPONENT_STATE_KEY,
  component: connect(mapStateToProps, tvScheduleActions)(TvChannelSchedule),
  reducer: tvChannelSelectionReducer,
}

function mountTvSchedule(){
  return reduxMount({
    [MOUNT_POINTS.TV_SCHEDULE_CHANNEL]: TvChannelScheduleContainer,
  })
}

const TV_SCHEDULE_FEATURE_ID = 'TvSchedule'

export default function initTvSchedule(){
  const shouldMountTvSchedule = isSupportedForDomain(TV_SCHEDULE_FEATURE_ID)
  if (shouldMountTvSchedule) {
    mountTvSchedule()
  }
  return shouldMountTvSchedule
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/tv_schedule_container/tvScheduleContainer.js